import { useQuery } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const QUERY = graphql(`
  query topBanner($id: ID!) {
    topBanner(id: $id) {
      ...TopBannerItem
    }
  }
`);

export function useTopBanner(id: string) {
  return useQuery(QUERY, {
    variables: {
      id,
    },
  });
}
